import React from 'react'

import FormulaInput, { FormulaInputProps } from 'common/fields/components/FormulaInput'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'

import cm from './FormulaPriceInput.module.css'

type FormulaPriceInputProps = Omit<FormulaInputProps, 'value'> & {
  value?: string | number | null
}

const FormulaPriceInput: React.ForwardRefRenderFunction<
  IMCTextEditorRef,
  FormulaPriceInputProps
> = ({ value, ...rest }, ref) => {
  return (
    <div className={cm.wrap}>
      <FormulaInput ref={ref} value={value == null ? '' : `${value}`} {...rest} />
    </div>
  )
}

export default React.forwardRef(FormulaPriceInput)
